
<!-- Список атрибутов -->

<template>

	<b-form-group :state="state" label="Параметр" label-for="input" invalid-feedback="Необходимо выбрать параметр">

		<v-select :clearable="false" id="input" :value="value" :reduce="obj => obj.key" :options="attrs" v-on:input="handle_input" clearSearchOnSelect required appendToBody/>

	</b-form-group>

</template>

<script>

export default
{
	props :
	{
		attrs : Array,
		value : String,
	},

	data()
	{
		return {

			state : null,

		}
	},

	beforeUpdate()
	{
		this.state = null
	},

	methods :
	{
		handle_input(event)
		{
			this.$emit("input", event)
		},

		check()
		{
			this.state = !!this.value

			return this.state
		}
	}
}

</script>

